export default {"src":"/_next/static/image/public/images/hamburger.68ca55a8838721aad6d816e36efee9c5.svg","height":59,"width":58};